import { useState, useCallback } from 'react';

const useSlotSelection = () => {
  const [selectedSlots, setSelectedSlots] = useState(new Set());

  // Always additive: toggle slot in/out of selection (no modifier key logic)
  const toggleSlot = useCallback((slot) => {
    if (!slot || !slot.name) return;

    const key = `${slot.row}-${slot.column}`;

    setSelectedSlots(prev => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedSlots(new Set());
  }, []);

  const getSelectedSlotData = useCallback((slots) => {
    if (!slots) return [];
    return slots.filter(s => selectedSlots.has(`${s.row}-${s.column}`));
  }, [selectedSlots]);

  // Derived: act mode is active when any slots are selected
  const isActMode = selectedSlots.size > 0;

  return {
    selectedSlots,
    toggleSlot,
    clearSelection,
    getSelectedSlotData,
    isActMode
  };
};

export default useSlotSelection;
